import { render, staticRenderFns } from "./DownloadableAttachment.vue?vue&type=template&id=57caebdb&scoped=true&"
import script from "./DownloadableAttachment.vue?vue&type=script&lang=js&"
export * from "./DownloadableAttachment.vue?vue&type=script&lang=js&"
import style0 from "./DownloadableAttachment.vue?vue&type=style&index=0&id=57caebdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57caebdb",
  null
  
)

export default component.exports